import requestAxios from '@/utils/request'

export function getListCourseApi (params) {
  return requestAxios.get('enter-score/course', {params})
}



// WEBPACK FOOTER //
// ./src/api/enter-score/course.js